import React from 'react'
import { Card } from 'components'

const AdminPrivacyStatementView = () => {
  return <Card>Nothing to show...</Card>
}

export default AdminPrivacyStatementView
